import { create } from 'zustand';

type NotificationsModalState = {
  isOpen: boolean;
  onContinue?: () => void | Promise<void>;
  openNotificationsModal: (onContinue?: () => void | Promise<void>) => void;
  closeNotificationsModal: () => void;
};

const initialState = {
  isOpen: false,
  onContinue: undefined,
};

export const useNotificationsModalStore = create<NotificationsModalState>(
  (set) => ({
    ...initialState,

    openNotificationsModal: (onContinue) => {
      set({
        isOpen: true,
        onContinue,
      });
    },

    closeNotificationsModal: () => {
      set(initialState);
    },
  }),
);
